export const LABS_KEY = 'appointmentLabs'
export const LABS_SERVICE_ID_KEY = 'appointmentLabsServiceId'
export const LABS_SERVICE_IDS = [10, 53]

const normalizeServiceId = (serviceId) => {
  if (serviceId == null || serviceId === '') return null
  return String(serviceId)
}

const parseJson = (raw) => {
  if (raw == null || raw === '') return null
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

const safeGetItem = (key) => {
  try {
    return (
      window.sessionStorage.getItem(key) ?? window.localStorage.getItem(key)
    )
  } catch {
    return null
  }
}

const safeSetItem = (key, value) => {
  try {
    window.sessionStorage.setItem(key, value)
    window.localStorage.removeItem(key)
  } catch {
    // ignore quota errors
  }
}

const safeRemoveItem = (key) => {
  try {
    window.sessionStorage.removeItem(key)
    window.localStorage.removeItem(key)
  } catch {
    // ignore
  }
}

export const isLabsScheduleService = (serviceId) =>
  LABS_SERVICE_IDS.includes(Number(serviceId))

/** Option identity for toggle/persist. Do not use serviceId — lab variants share the parent service. */
export const getLabSelectionKey = (lab) => {
  if (lab == null || typeof lab !== 'object') return ''
  if (lab.value != null && lab.value !== '') return String(lab.value)
  if (lab.label != null && lab.label !== '') return String(lab.label)
  if (lab.name != null && lab.name !== '') return String(lab.name)
  return ''
}

export const toggleSelectedLab = (selectedLabs, item) => {
  const current = Array.isArray(selectedLabs) ? selectedLabs : []
  const labKey = getLabSelectionKey(item)
  if (!labKey) return current

  const exists = current.some((lab) => getLabSelectionKey(lab) === labKey)
  if (exists) {
    return current.filter((lab) => getLabSelectionKey(lab) !== labKey)
  }
  return [...current, item]
}

export const isAppointmentLabsForService = (serviceId) => {
  const stored = normalizeServiceId(safeGetItem(LABS_SERVICE_ID_KEY))
  const current = normalizeServiceId(serviceId)
  return Boolean(stored && current && stored === current)
}

export const clearLabsStorage = () => {
  safeRemoveItem(LABS_KEY)
  safeRemoveItem(LABS_SERVICE_ID_KEY)
}

export const persistSelectedLabs = (serviceId, labs) => {
  const id = normalizeServiceId(serviceId)
  const list = Array.isArray(labs) ? labs : []
  if (!id || !isLabsScheduleService(id) || list.length === 0) {
    clearLabsStorage()
    return
  }
  safeSetItem(LABS_KEY, JSON.stringify(list))
  safeSetItem(LABS_SERVICE_ID_KEY, id)
}

export const readLabsForService = (serviceId) => {
  if (!isLabsScheduleService(serviceId) || !isAppointmentLabsForService(serviceId)) {
    return []
  }
  const value = parseJson(safeGetItem(LABS_KEY))
  return Array.isArray(value) ? value : []
}

export const resolveScheduleLabs = (laboratories) => {
  if (!Array.isArray(laboratories) || laboratories.length === 0) return []
  return laboratories.map((lab) => [lab.serviceId])
}
